import React from "react";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import { GET_FINANCIALS } from "../services/Apis";
import axios from "axios";
import { useEffect, useState } from "react";

const Terms = () => {
  const [SidebarState, setSidebarState] = useState(false);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const user = {
    id: encStorage.getItem("id"),
    name: encStorage.getItem("name"),
    client_code: encStorage.getItem("client_code"),
    id: encStorage.getItem("id"),
  };
  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content">
          <div className="container mt-3">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <h2 className="text-center mb-3 text-primary">
                  Trading Related Terms & Conditions
                </h2>
                <div className="card1 shadow1 border-0">
                  <div className="card-body1 p-2">
                    <table className="table table-bordered table-hover align-middle">
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            <strong>
                              Operating/Line/Manipulated/Chamka/LTP Trades
                            </strong>{" "}
                            will be removed anytime.
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            <strong>Scalping</strong> is not allowed.
                          </td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            <strong>BTST/STBT Not Allowed:</strong> Any position
                            opened after 3:00 PM and closed the next day before
                            9:45 AM will not be allowed. Profits from such
                            trades will be removed by the admin.
                          </td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>
                            The margin of a company whose financial results are
                            to be announced tomorrow will be increased to{" "}
                            <strong>5%</strong> before market close.
                          </td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            <strong>Dividend/Bonus</strong> will be adjusted
                            based on the exchange circular.
                          </td>
                        </tr>
                        <tr>
                          <td>6</td>
                          <td>
                            <strong>
                              Arbitrage, Hedging, Jobbing, Algorithmic Jobbing
                            </strong>{" "}
                            is not allowed. Trades will be removed anytime.
                          </td>
                        </tr>
                        <tr>
                          <td>7</td>
                          <td>
                            If unable to close positions due to software issues,
                            contact support via WhatsApp. Positions will be
                            closed at prevailing rates upon receipt of the
                            message. Responsibility lies with the client to
                            inform support.
                          </td>
                        </tr>
                        <tr>
                          <td>8</td>
                          <td>
                            <strong>Order Execution:</strong> All orders will be
                            executed at bid and ask prices.
                          </td>
                        </tr>
                        <tr>
                          <td>9</td>
                          <td>
                            <strong>VPN Usage:</strong> VPN is strictly
                            prohibited. Profits from trades executed using a VPN
                            will be removed.
                          </td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>
                            <strong>Group Trading:</strong> Requires prior
                            permission.
                          </td>
                        </tr>
                        <tr>
                          <td>11</td>
                          <td>
                            If the <strong>Introducer</strong> fails to inform
                            the client, the mediator will be responsible for
                            disputes, and the Introducer will be liable for
                            payments.
                          </td>
                        </tr>
                        <tr>
                          <td>12</td>
                          <td>
                            Any <strong>Introducing Broker</strong> found
                            engaging in unethical practices will be terminated
                            or banned.
                          </td>
                        </tr>
                        <tr>
                          <td>13</td>
                          <td>
                            <strong>Account Sharing:</strong> Sharing accounts
                            or allowing managers to engage in unethical
                            practices may lead to account holds and fund
                            blocking.
                          </td>
                        </tr>
                        <tr>
                          <td>14</td>
                          <td>
                            <strong>Cross Orders and IP Restrictions:</strong>{" "}
                            Trades with the same IP or multiple IDs using the
                            same IP are prohibited. Profitable trades may be
                            removed without notice.
                          </td>
                        </tr>
                        <tr>
                          <td>15</td>
                          <td>
                            <strong>Margin Shortfalls:</strong> Clients must
                            ensure timely deposits. Liquidated positions will
                            not be reopened.
                          </td>
                        </tr>
                        <tr>
                          <td>16</td>
                          <td>
                            <strong>
                              Cannot take trades due to stopped prices:
                            </strong>{" "}
                            Please note that whenever the rate of any
                            script/commodity is Stopped from the exchange for 30
                            seconds, the system stops new trades in that script
                            and traders see a message "Trades cannot be taken
                            due to Stopped prices". This prevents any script
                            from trading at wrong rates, it is not the system
                            that stops the rate but the rate is halted at the
                            exchange due to which the rate is halted in our
                            system as well. If the rate is not updated in any
                            script for 30 seconds, the system will not accept
                            any trade. This mostly happens in those scrips which
                            have less trading.
                          </td>
                        </tr>
                        <tr>
                          <td>17</td>
                          <td>
                            <strong>Advance Stop Loss not allowed:</strong> The
                            client can place Stop Loss order only for the
                            positions which are already opened. New positions
                            which are opened using BUY/SELL Stop Loss Orders may
                            be removed any time and any Pending BUY/SELL Stop
                            Order may be cancelled at any time. It is the sole
                            Discretion of the Company.
                          </td>
                        </tr>
                        <tr>
                          <td>18</td>
                          <td>
                            <strong>Bonus/Merge/Demerge/Split:</strong> In case
                            of Bonus/Merge/Demerge/Split in any stock all open
                            positions will be closed at the available prices
                            when market is closing before ex-date.
                          </td>
                        </tr>
                        <tr>
                          <td>19</td>
                          <td>
                            <strong>PNL Calculation:</strong>
                            Profit and loss will be calculated at the available
                            bid and ask prices only but not on previous day
                            closing.
                          </td>
                        </tr>
                        <tr>
                          <td>20</td>
                          <td>
                            <strong>
                              Charts: Screenshots will not be valid.
                            </strong>
                            Orders are executing of Bid and Ask prices and
                            charts are made on Last Trading Prices (LTP). So
                            Sharing screenshots of chats will be the valid
                            reason for any order executed.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row mt-3 justify-content-center">
              <div className="col-lg-10">
                <h2 className="text-center mb-3 text-primary">
                  Credit Offer Terms & Conditions
                </h2>
                <div className="card1 shadow1 border-0">
                  <table
                    border="1"
                    className="table table-bordered table-striped w-100 align-middle"
                  >
                    <tbody>
                      <tr>
                        <td>1.</td>
                        <td>
                          Each user is permitted to operate <b>only one account</b>. Multiple
                          accounts under the same user are strictly prohibited.
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>
                          Users found with multiple accounts will face{" "}
                          <b>permanent termination</b>, and all associated accounts will be
                          blocked immediately.
                        </td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>
                          The <b>maximum withdrawal limit</b> using the Credit Offer is{" "}
                          <b>₹1,000</b>.
                        </td>
                      </tr>
                      <tr>
                        <td>4.</td>
                        <td>
                          At the time of a <b>withdrawal request, all open positions must be closed (NIL or 0)</b>.
                        </td>
                      </tr>
                      <tr>
                        <td>5.</td>
                        <td>
                          Any remaining profit earned from this credit will be{" "}
                          <b>flushed out</b> once the client has reached the{" "}
                          <b>maximum withdrawal limit</b>.
                        </td>
                      </tr>
                      <tr>
                        <td>6.</td>
                        <td>
                          The <b>₹1,000 credit</b> will remain active until it is fully
                          utilized or settled through liquidation.
                        </td>
                      </tr>
                      <tr>
                        <td>7.</td>
                        <td>
                          If a client <b>makes a deposit before submitting a withdrawal request</b>, all{" "}
                          <b>profits made before the deposit will be flushed out</b>. However, the{" "}
                          <b>₹1,000 credit</b> will remain as per the allowed withdrawal limit.
                        </td>
                      </tr>
                      <tr>
                        <td>8.</td>
                        <td>
                          After utilizing the <b>maximum withdrawal offer</b>, clients may deposit funds and continue trading with{" "}
                          <b>no restrictions on further deposits or withdrawals</b>.
                        </td>
                      </tr>
                      <tr>
                        <td>9.</td>
                        <td>
                          Clients <b>must make a deposit before trading</b>. Any{" "}
                          <b>profits generated using the credit before making a deposit</b> will not be considered valid.
                        </td>
                      </tr>
                      <tr>
                        <td>10.</td>
                        <td>
                          If a client incurs <b>losses after making a deposit</b>, the available{" "}
                          <b>credit will be adjusted against the loss instantly</b>.
                        </td>
                      </tr>
                      <tr>
                        <td>11.</td>
                        <td>
                          Credits are <b>non-transferable</b> and cannot be{" "}
                          <b>exchanged for cash or transferred between accounts</b>.
                        </td>
                      </tr>
                      <tr>
                        <td>12.</td>
                        <td>
                          If an account exhibits <b>suspicious behavior</b> or is suspected of{" "}
                          <b>fraudulent activity</b>, the company reserves the right to{" "}
                          <b>terminate the account without prior notice</b>.
                        </td>
                      </tr>
                      <tr>
                        <td>13.</td>
                        <td>
                          The company may impose additional <b>restrictions based on location and trading patterns</b>.
                        </td>
                      </tr>
                      <tr>
                        <td>14.</td>
                        <td>
                          Any attempt to <b>manipulate, abuse, or exploit</b> the credit system—including the use of{" "}
                          <b>bots, arbitrage, or other unfair means</b>—will result in{" "}
                          <b>immediate disqualification and account suspension</b>.
                        </td>
                      </tr>
                      <tr>
                        <td>15.</td>
                        <td>
                          The company reserves the right to <b>modify or terminate this credit offer</b> at any time{" "}
                          <b>without prior notice</b>.
                        </td>
                      </tr>
                      <tr>
                        <td>16.</td>
                        <td>
                          This offer is available for a <b>limited time period</b> and may be withdrawn or modified at the company’s discretion.
                        </td>
                      </tr>
                      <tr>
                        <td>17.</td>
                        <td>
                          By using this credit, users <b>agree to these terms</b> and acknowledge that any{" "}
                          <b>violation may lead to loss of eligibility and permanent account closure</b>.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
